export default "__VITE_ASSET__hG$bhApZ__"